import 'styles/Gallery.less'
import 'styles/PhotoFeed.less'
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames/bind'
import assets from 'modules/assets'
import Loading from 'components/Utils/Loading'
import Splash from 'components/Gallery/GallerySplash'
import Overview from 'components/Gallery/GalleryOverview'
import Camp2016PhotoFeed from 'components/Gallery/Camp2016PhotoFeed'
import Camp2017PhotoFeed from 'components/Gallery/Camp2017PhotoFeed'
import * as actions from 'actions'

class GalleryIndex extends Component {
  constructor(props) {
    super(props)
    this.state = {
      subComponentLoaded: false,
      alertIsMinimized: false,
      alertIsHidden: false,
      headerIsHidden: false,
      footerIsHidden: false,
      campId: this.props.params.campid,
      year: this.props.params.year,
      isNavigateGallery: false,
      showSplash: true
    }
    this.CAMPS = {
      '2016': ['bali', 'chiba', 'danube'],
      '2017': ['bali', 'chiba', 'danube', 'france'],
      '2018': ['japan1', 'usa1', 'japan2', 'usa2'],
      '2019': ['japan']
    }
    this.YEARS = ['2016', '2017', '2018', '2019']
    this.onLoad = this.onLoad.bind(this)
    this.subComponentLoaded = this.subComponentLoaded.bind(this)
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      alertIsMinimized: nextProps.alertIsMinimized,
      alertIsHidden: nextProps.alertIsHidden,
      headerIsHidden: nextProps.headerIsHidden,
      footerIsHidden: nextProps.footerIsHidden,
      isNavigateGallery: nextProps.isNavigateGallery,
      campId: nextProps.params.campid,
      year: nextProps.params.year
    })
  }
  onLoad(doc) {
    this.setState({
      docLoaded:true,
      attributes:doc.getAttributes()
    })
  }
  subComponentLoaded() {
    this.setState({
      subComponentLoaded: true
    })
  }
  componentWillUnmount() {
    this.props.dispatch(actions.token.toggleHideAlert(false))
    let url = assets('menu.md')
    this.props.dispatch(actions.token.fetchMenu(url))
    this.props.dispatch(actions.token.isNavigateGallery(false))
  }
  componentWillMount() {
  }
  componentDidMount() {
    //this.props.dispatch(actions.token.toggleFooter(true))
    //this.props.dispatch(actions.token.toggleHeader(true))
    this.props.dispatch(actions.token.toggleHideAlert(true))
    let url = assets('menu_gallery_2016.md')
    this.props.dispatch(actions.token.fetchMenu(url))

    this.props.dispatch(actions.token.isNavigateGallery(true))
  }
  navigateOverview() {
    this.setState({
      showSplash: true
    })
  }
  getSplashComponent() {
    let loading = false //!this.state.subComponentLoaded || !this.state.footerIsHidden
    let loadingClass = classNames({'no-display': !loading})
    let component

    let splashContainerStyle = { top: this.state.splashTopAttr }
    let splashClass = classNames('camp-2016-splash-container', {'no-display': loading})
    let splash = (
      <div className={splashClass} style={splashContainerStyle} onClick={this.navigateOverview.bind(this)}>
        <Splash imageLoadedHandler={this.subComponentLoaded} {...this.props}/>
      </div>
    )
    component = splash

    return (
      <div style={{overflow: 'hidden'}}>
        <Loading className={loadingClass}/>
        {component}
      </div>
    )
  }
  getOverviewComponent() {
    let loading = false //!this.state.subComponentLoaded || !this.state.footerIsHidden
    let loadingClass = classNames({'no-display': !loading})
    let component

    let overviewContainerStyle = { top: this.state.overviewTopAttr }
    let overviewClass = classNames('camp-2016-overview-container', {'no-display': loading})
    let overview = (
      <div className={overviewClass} style={overviewContainerStyle}>
        <Overview year={this.state.year} camps={this.CAMPS} {...this.props}/>
      </div>
    )
    component = overview

    return (
      <div style={{overflow: 'hidden'}}>
        <Loading className={loadingClass}/>
        {component}
      </div>
    )
  }
  getPhotoFeedComponent() {
    let photoFeedContainerStyle = {}, photoFeedClass
    switch (this.state.year) {
      case '2016':
        photoFeedClass = classNames('camp-2016-photo-feed-container', 'fade-in')
        return (
          <div className={photoFeedClass} style={photoFeedContainerStyle}>
            <Camp2016PhotoFeed year={this.state.year} campId={this.state.campId}/>
          </div>
        )
      case '2017':
      case '2018':
      case '2019':
        photoFeedClass = classNames('camp-2017-photo-feed-container', 'fade-in')
        return (
          <div className={photoFeedClass} style={photoFeedContainerStyle}>
            <Camp2017PhotoFeed year={this.state.year} campId={this.state.campId}/>
          </div>
        )
    }
  }
  render() {
    if (!this.state.isNavigateGallery) {
      return (<Loading/>)
    }
    let displayComponent
    if (this.state.campId && this.state.year && this.CAMPS[this.state.year].indexOf(this.state.campId.toLowerCase()) != -1)
      displayComponent = this.getPhotoFeedComponent()
    else if (this.state.year && this.YEARS.indexOf(this.state.year) != -1)
      displayComponent = this.getOverviewComponent()
    else
      displayComponent = this.getSplashComponent()

  	return (
  		<div className="camp-2016-container">
        {displayComponent}
  		</div>

  	)
	}
}

GalleryIndex.contextTypes = {
}
GalleryIndex.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location,
    alertIsMinimized: state.token.alertIsMinimized,
    alertIsHidden: state.token.alertIsHidden,
    headerIsHidden: state.token.headerIsHidden,
    footerIsHidden: state.token.footerIsHidden,
    isNavigateGallery: state.token.isNavigateGallery
  }
}

export default connect(mapStateToProps)(GalleryIndex)



// WEBPACK FOOTER //
// ./src/components/Gallery/GalleryIndex.js